import dayjs from 'dayjs';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'ScheduleList',
  props: {
    schedules: {
      default: () => [],
      type: Array,
    },
    schedule: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      enable: false,
    };
  },
  computed: {
    hasSchedule() {
      return !isEmpty(this.schedule);
    },
    isScheduleFinish() {
      return this.hasSchedule && isEmpty(this.schedules);
    },
    orderCreateTime() {
      const { orderCreateTime } = this.schedule || {};
      return orderCreateTime ? dayjs(orderCreateTime).format('A hh:mm') : null;
    },
    orderEndTime() {
      const { orderPeriodTime } = this.schedule || {};
      const { end } = orderPeriodTime || {};
      return end ? dayjs(end).format('A hh:mm') : '';
    },
    orderStartTime() {
      const { orderPeriodTime } = this.schedule || {};
      const { start } = orderPeriodTime || {};
      return start ? dayjs(start).format('A hh:mm') : '';
    },
    tableData() {
      return this.schedules.reduce((list, {
        groupBuyingCreateTime: createTime,
        groupBuyingStartTime: startTime,
        groupBuyingReceiveTimes: receiveTimes,
      }, parentIndex) => list.concat(receiveTimes.map(([receiveStart, receiveEnd], childIndex) => {
        const item = {
          createDate: createTime ? dayjs(createTime).format('YYYY/MM/DD (dd)') : '',
          index: parentIndex + 1,
          receiveDateEnd: receiveEnd ? dayjs(receiveEnd).format('YYYY/MM/DD') : '',
          receiveDateStart: receiveStart ? dayjs(receiveStart).format('YYYY/MM/DD') : '',
          receiveTimeEnd: receiveEnd ? dayjs(receiveEnd).format('A hh:mm') : '',
          receiveTimeStart: receiveStart ? dayjs(receiveStart).format('A hh:mm') : '',
          startDate: dayjs(startTime).format('YYYY/MM/DD'),
        };
        if (childIndex > 0) {
          item.createDate = '';
          item.index = '';
          item.startDate = '';
        }
        return item;
      })), []);
    },
  },
};
